
import { defineComponent, ref, onMounted } from 'vue'
import { useRoute } from 'vue-router';
import KTFile3 from "@/components/files/File3.vue";
import FormsFisu from '@/components/widgets/mixed/FormsFisu.vue';
import { errManager } from "@/core/config/Tools";
import MultimediaService from '@/core/services/MultimediaService'
import { useI18n } from "vue-i18n/index";

export default defineComponent({
    name: "tournament-home",
    components: { FormsFisu, KTFile3 },
    setup() {
        const { t } = useI18n();
        const loader = ref(false)
        const route = useRoute();
        const { id } = route.params
        const listDocs = ref<any>([])
        
        const getData = async() => {
            loader.value = true
            await MultimediaService.getData({idevent: id, tabla: 'events'})
            .then((res)=>{
                listDocs.value = res.data
                loader.value = false
            }).catch(({response})=>{
                loader.value = false
                errManager(response)
            })
        }

        onMounted(()=>{
            getData()
        })

        return {
            t,
            id,
            loader,
            listDocs,
            getData
        }
    },
})
